import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import CelltrionCare from "../popup/celltrionCare";
import { Link } from "react-router-dom";
import bgLayer from "../../assets/img/bg-layer.png";
// NOTE: FPO card art from the Figma comp (Avtozma card with the OMLYCLO logo,
// still carrying US-AVT-25-00015). Swap when the final OMLYCLO card is approved.
import cares from "../../assets/img/omlyclo-card.png";

export const OmlycloEntry = () => {
  const [modalShow, setModalShow] = useState(false);
  const { category } = useParams();
  const productName = category;

  // Desktop and mobile render the same copy, so it lives in one place.
  const eligibilityCopy = (
    <>
      <h5>
        Commercially insured patients may be able to receive assistance through
        the Celltrion CARES<sup className="reg">&reg;</sup> Co-pay Assistance
        Program*
      </h5>
      <ul>
        <li>If eligible, patients may pay as little as $0 for OMLYCLO</li>
        <li>
          Celltrion CARES provides assistance to help with patient out-of-pocket
          costs for OMLYCLO
        </li>
      </ul>
      <h5>
        Eligibility criteria for the Celltrion CARES Co-pay Assistance Program:
      </h5>
      <ul>
        <li>Must have commercial or private insurance</li>
        <li>Must not have Medicare, Medicaid, or other government insurance</li>
        <li>Must be for an approved indication for OMLYCLO</li>
        <li>
          Must meet certain guidelines set forth in the{" "}
          <a
            href="#"
            onClick={() => setModalShow(true)}
            style={{ color: "#000000", textDecoration: "underline" }}
          >
            Terms and Conditions
          </a>{" "}
          for the Celltrion CARES Co-pay Assistance Program
        </li>
      </ul>
    </>
  );

  const claimsInstructions = (
    <div className="claims-box">
      <h5>Instructions for medical claims processing</h5>
      <p>
        The OMLYCLO co-pay card can be used for both pharmacy and medical
        claims. To request reimbursement for a medical claim, submit a completed{" "}
        <a
          href="/files/Provider_Payment_Form.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <strong>Provider Payment Form</strong>
        </a>
        * along with the following
      </p>
      <ul>
        <li>CMS 1500-form or UB-40 claim form</li>
        <li>Patient&rsquo;s Explanation of Benefits (EOB)</li>
      </ul>
      <p>Fax the completed form and supporting documentation to: 877-431-6444.</p>
      <p className="disclaimer">
        <strong>NOTE:</strong> The provider payment form only needs to be
        submitted once per patient unless there are changes to the billing
        contact or payment information.
      </p>
    </div>
  );

  return (
    <>
      <section className={`${productName}-product-entry`}>
        <Container fluid>
          <div className="steqeyma-text">
            <Row className="enrollContent">
              <Col xs={12} md={8}>
                <h4>LOOKING FOR</h4>
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <h1 style={{ position: "relative", display: "inline-block" }}>
                    CO-PAY SUPPORT FOR OMLYCLO<sup className="reg">&reg;</sup>?
                  </h1>
                </div>
                <Link to="/inquiry-form/omlyclo" className="theme-btn">
                  Enroll Today
                </Link>
                <div className="entry-content-desktop">
                  {eligibilityCopy}
                  {claimsInstructions}
                </div>
              </Col>
              <Col
                xs={12}
                md={4}
                className="entry-image-desktop"
                style={{ marginTop: "40px" }}
              >
                <img src={cares} className="card-image" alt="" />
              </Col>
            </Row>
          </div>
        </Container>
        <div className="steqeyma-text">
          <Col xs={12} md={4} className="entry-image-mobile mb-2">
            <img src={cares} style={{ width: "100%", height: "auto" }} alt="" />
          </Col>
          <div className="entry-content-mobile">
            {eligibilityCopy}
            {claimsInstructions}
          </div>
        </div>
        <img src={bgLayer} className="bgLayer" alt="" />
      </section>
      <CelltrionCare show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};
